/**
 * FloatingNotices - the fixed bottom-right region the undo toast has
 * always occupied (bottom across narrow screens), shared with the busy
 * notice (build-specs/busy-says-so-and-retries-once.md C9). Children
 * stack, busy notice above the toast, so the two never cover each other;
 * the toast alone renders exactly where and as it did before.
 */
import type { ReactNode } from 'react';

/** The floating message's box: the undo toast's, reused by the busy notice. */
export const FLOATING_BOX_CLS = 'bg-ink text-cream px-4 py-3 rounded-lg shadow-lg';

export function FloatingNotices({ children }: { children: ReactNode }): ReactNode {
  return (
    <div className="fixed bottom-4 inset-x-4 md:left-auto md:right-4 md:max-w-sm z-50 flex flex-col">
      {children}
    </div>
  );
}
